import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-collaboration',
  templateUrl: './collaboration.component.html',
  styleUrl: './collaboration.component.scss',
})
export class CollaborationComponent implements OnInit {
  readonly viewCollaborationRelatedTabs: string[] = ['app.dcr-portal.collaboration.all'];

  selectedIndex = 0;
  tabRoutes = ['list', 'create'];

  constructor(
    private router: Router,
    private activateRoute: ActivatedRoute,
    public authService: AuthService,
  ) {}

  ngOnInit() {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      const current = this.activateRoute.firstChild?.snapshot.url[0]?.path;
      if (current) {
        this.selectedIndex = this.getTabIndexForRoute(current);

        if (current === 'create') {
          this.selectedIndex = this.getTabIndexForRoute('list');
        }
      }
    });

    const initial = this.activateRoute.firstChild?.snapshot.url[0]?.path;
    if (initial) {
      this.selectedIndex = this.getTabIndexForRoute(initial);
    }
  }

  private getTabIndexForRoute(routePath: string): number {
    return this.tabRoutes.indexOf(routePath) !== -1 ? this.tabRoutes.indexOf(routePath) : 0;
  }

  onTabChange(index: number) {
    const currentRoute = this.activateRoute.firstChild?.snapshot.url[0]?.path;
    const targetRoute = this.tabRoutes[index];
    if (currentRoute === 'create' && targetRoute === 'list') {
      return;
    }

    this.router.navigate([targetRoute], { relativeTo: this.activateRoute });
  }
}
